// =============================================================================
// Sirène « nouvelle commande » — son FORT identique au legacy Big Burger.
// PARTAGÉ entre la tablette (OrderList) ET le back-office (OrdersAdmin) → un seul
// son cohérent partout. Trio « BIP-BIP-BIP » strident (onde square 2400/1800 Hz),
// volume 0,95. Durée paramétrable ; AudioContext persistant + resume (iOS).
// =============================================================================
let _alertCtx: AudioContext | null = null;
let _alertNodes: { osc: OscillatorNode; gain: GainNode }[] = [];

/** Coupe immédiatement la sirène en cours. */
export function stopOrderAlert(): void {
  _alertNodes.forEach((n) => {
    try {
      n.osc.stop();
    } catch {
      /* déjà arrêté */
    }
  });
  _alertNodes = [];
}

/** Joue la sirène forte pendant `duration` ms (défaut 5 s). */
export function playOrderAlert({ duration = 5000, volume = 0.95 }: { duration?: number; volume?: number } = {}): void {
  try {
    stopOrderAlert();
    const AC =
      window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!_alertCtx || _alertCtx.state === 'closed') _alertCtx = new AC();
    const ctx = _alertCtx;
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {
        try {
          _alertCtx = new AC();
        } catch {
          /* ignore */
        }
      });
    }
    const FREQ_HIGH = 2400;
    const FREQ_LOW = 1800;
    const BEEP_DURATION = 0.18;
    const BEEP_GAP = 0.08;
    const TRIO_GAP = 0.55;
    const playBeep = (t0: number, freq: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.setValueAtTime(freq, t0);
      osc.connect(gain);
      gain.connect(ctx.destination);
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(volume, t0 + 0.01);
      gain.gain.setValueAtTime(volume, t0 + BEEP_DURATION - 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + BEEP_DURATION);
      osc.start(t0);
      osc.stop(t0 + BEEP_DURATION + 0.05);
      _alertNodes.push({ osc, gain });
    };
    let t = ctx.currentTime + 0.05;
    const endTime = t + duration / 1000;
    while (t < endTime) {
      playBeep(t, FREQ_HIGH);
      playBeep(t + (BEEP_DURATION + BEEP_GAP), FREQ_LOW);
      playBeep(t + 2 * (BEEP_DURATION + BEEP_GAP), FREQ_HIGH);
      t += 3 * (BEEP_DURATION + BEEP_GAP) + TRIO_GAP;
    }
  } catch {
    /* audio indisponible — silencieux */
  }
}
